import React from "react";
import { default as DropdownBootstrap } from "react-bootstrap/Dropdown";
import BootstrapDropdownItem from "react-bootstrap/DropdownItem";
import { styleBlock } from "../styleBlock";
export default class Dropdown extends React.PureComponent {
    render() {
        const { id, title, variant, size, disabled, block, className, children } = this.props;
        const classNames = styleBlock("dropdown");
        const cn = classNames({
            block: block,
        }).mix([className]);
        return (React.createElement(DropdownBootstrap, { className: cn.toString() },
            React.createElement(DropdownBootstrap.Toggle, { variant: variant, size: size, disabled: disabled, id: id, className: classNames("btn")
                    .mix(block ? "btn-block" : undefined)
                    .toString() }, title),
            React.createElement(DropdownBootstrap.Menu, { renderOnMount: true }, children)));
    }
}
Dropdown.Item = BootstrapDropdownItem;
//# sourceMappingURL=index.js.map